import { useAppSelector } from "@app/store";
import Warning from "@assets/icons/warning-filled.svg";
import { Button } from "@components/button";
import { GlobalLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { useDevicesDispatch } from "@features/device";
import { useCallback } from "react";
import styles from "./stop-device-confirm.module.scss";

type Props = {
  hide: () => void;
  isOpen: boolean;
  deviceId: string;
};

export const StopDeviceConfirm = ({ hide, isOpen, deviceId }: Props) => {
  const isUpdating = useAppSelector((state) => state.device.isUpdating);
  const { updateDevice } = useDevicesDispatch();

  const onConfirm = useCallback(async () => {
    await updateDevice({ deviceId, at_work: false });
    hide();
  }, [deviceId, hide, updateDevice]);

  return (
    <>
      <Modal isOpen={isOpen} onClose={hide} className={styles.confirm}>
        <div className={styles.confirmContainer}>
          <Warning />
          <p className={styles.title}>Вы уверены?</p>
          <p className={styles.subTitle}>
            Все реквизиты подключенные к устройству будут отключены
          </p>
        </div>
        <div className={styles.buttons}>
          <Button onClick={onConfirm}>Да</Button>
          <Button type="danger" onClick={hide}>
            Нет
          </Button>
        </div>
      </Modal>
      {isUpdating && <GlobalLoader />}
    </>
  );
};
